import type { DocMigration } from "../docMigration";

function bySortIndex(a: any, b: any): number {
  return (a.sortIndex ?? 0) - (b.sortIndex ?? 0);
}

function hasRoofType(setting: any): boolean {
  return setting?.type === "ROOF_SETTINGS" && setting.roofType !== undefined && setting.roofType !== null;
}

const migration: DocMigration = {
  id: "20260717_roof_instance_type_overrides",
  description: "Preserve the type of existing roof instances as an explicit override",
  apply(json: any) {
    const roofs = json.roofs ?? {};
    if (Object.keys(roofs).length === 0) {
      return json;
    }

    const settings = json.settings ?? {};
    const settingsSets = json.settingsSets ?? {};
    // Settings fragments in the same set merge by sortIndex, so the last roof type must win.
    const sortedSettings = (Object.values(settings) as any[]).sort(bySortIndex);
    const roofTypesBySetId = new Map<string, string>();
    for (const setting of sortedSettings) {
      if (hasRoofType(setting)) {
        roofTypesBySetId.set(setting.parentId, setting.roofType);
      }
    }

    let globalRoofType = "DEFAULT";
    let formulaGatedGlobalType = false;
    for (const settingsSet of (Object.values(settingsSets) as any[]).sort(bySortIndex)) {
      const roofType = roofTypesBySetId.get(settingsSet.id);
      if (settingsSet.type === "TARGETED" || roofType === undefined) {
        continue;
      }
      if (settingsSet.disabled?.type === "FORMULA") {
        formulaGatedGlobalType = true;
      } else if (settingsSet.disabled !== true) {
        globalRoofType = roofType;
        formulaGatedGlobalType = false;
      }
    }

    const targetedRoofTypes = new Map<string, string>();
    const formulaGatedTargetedRoofIds = new Set<string>();
    for (const entitySetting of (Object.values(json.entitySettings ?? {}) as any[]).sort(bySortIndex)) {
      const settingsId = entitySetting.settingsOrSettingsSetId;
      const directSetting = settings[settingsId];
      if (hasRoofType(directSetting)) {
        targetedRoofTypes.set(entitySetting.entityId, directSetting.roofType);
        formulaGatedTargetedRoofIds.delete(entitySetting.entityId);
        continue;
      }

      const settingsSet = settingsSets[settingsId];
      const roofType = roofTypesBySetId.get(settingsId);
      if (!settingsSet || roofType === undefined) {
        continue;
      }
      if (settingsSet.disabled?.type === "FORMULA") {
        formulaGatedTargetedRoofIds.add(entitySetting.entityId);
        targetedRoofTypes.delete(entitySetting.entityId);
      } else if (settingsSet.disabled !== true) {
        targetedRoofTypes.set(entitySetting.entityId, roofType);
        formulaGatedTargetedRoofIds.delete(entitySetting.entityId);
      }
    }

    for (const roof of Object.values(roofs) as any[]) {
      roof.roofSettings ??= {};
      if (roof.roofSettings.roofType !== undefined && roof.roofSettings.roofType !== null) {
        continue;
      }

      const targetedRoofType = targetedRoofTypes.get(roof.id);
      if (formulaGatedTargetedRoofIds.has(roof.id) || (targetedRoofType === undefined && formulaGatedGlobalType)) {
        continue;
      }
      roof.roofSettings.roofType = targetedRoofType ?? globalRoofType;
    }

    return json;
  },
};

export default migration;
